import { initContract } from "@ts-rest/core";
import { z } from "zod";
import { ErrorMessageSchema } from "@common/schemas/error.schema";
import {
    integrationCoaMappingSchema,
    integrationCoaMappingsResponseSchema,
    updateIntegrationCoaMappingBodySchema,
} from "@common/schemas/domains/accounting/integrationCoaMapping.schema";
import { ConnectionProvider } from "@common/types/integrationConnection";

const c = initContract();

/**
 * Per-entity mapping of an integration provider's transaction types to the
 * CoA accounts its gl-first sync posts to.
 */
export const integrationCoaMappingContract = c.router(
    {
        getMappings: {
            method: "GET",
            path: "/:entityId/:provider",
            pathParams: z.object({
                entityId: z.coerce.number(),
                provider: z.nativeEnum(ConnectionProvider),
            }),
            responses: {
                200: integrationCoaMappingsResponseSchema,
                404: ErrorMessageSchema,
            },
        },
        updateMapping: {
            method: "PATCH",
            path: "/:entityId/mappings/:mappingId",
            pathParams: z.object({
                entityId: z.coerce.number(),
                mappingId: z.string().uuid(),
            }),
            body: updateIntegrationCoaMappingBodySchema,
            responses: {
                200: integrationCoaMappingSchema,
                400: ErrorMessageSchema,
                403: ErrorMessageSchema,
                404: ErrorMessageSchema,
            },
        },
    },
    { pathPrefix: "/integration-coa-mapping" },
);
